import { connect } from "react-redux";
import {
  editAppointmentModalUpdate,
  editAppointmentModalConfirm,
  toggleApptEditCrew,
  editAppointmentModalUpdateConfirm,
  editAppointmentModalIndividualConfirm,
  editAppointmentModalSplitConfirm,
  toggleAppointmentModal,
} from "../../../redux/modals";
import AppointmentCalendarModal from "./AppointmentCalendarModal";
import {
  searchCustomers,
  searchDatasheets,
  searchJobs,
} from "../../../redux/searchAppointments";
import { toggleAppointmentCrew } from "../../../redux/modals/appintmentCalendarModal";

const mapStateToProps = (state) => ({
  ...state,
  show: state.modals.appintmentCalendarModal.show,
  loading: state.modals.appintmentCalendarModal.loading,
  appointmentTypes: state.dropdowns.appointmentTypes,
  customers: state.searchAppointments.customers,
  equipment: state.modals.appintmentCalendarModal.equipment,
  resources: state.modals.appintmentCalendarModal.resources,
  datasheets: state.searchAppointments.datasheets,
  jobs: state.searchAppointments.jobs,
  employees: state.searchEmployees.employees,
  isApptEditCrewEnabled:
    state.modals.appintmentCalendarModal.isApptEditCrewEnabled,
  form: state.modals.appintmentCalendarModal.form,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (updates) => dispatch(editAppointmentModalUpdate(updates)),
  onConfirm: () => dispatch(editAppointmentModalConfirm()),
  onIndividualConfirm: () => dispatch(editAppointmentModalIndividualConfirm()),
  onSplitConfirm: () => dispatch(editAppointmentModalSplitConfirm()),
  onEditConfirm: () => dispatch(editAppointmentModalUpdateConfirm()),
  onHide: () => dispatch(toggleAppointmentModal({ show: false })),
  onToggleEditCrew: () => dispatch(toggleAppointmentCrew()),
  onSearchCustomers: (query) => dispatch(searchCustomers(query)),
  onSearchDatasheets: (query, customerId) =>
    dispatch(searchDatasheets(query, customerId)),
  onSearchJobs: (query, customerId) => dispatch(searchJobs(query, customerId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentCalendarModal);
